import { buildApiUrl } from 'fake-db/apiConfig'
import Mock from '../../mock'
import shortId from 'shortid'
import axios from 'axios.js'


const getAllColorServer = async ()=>{
    const response = await axios.get(buildApiUrl('reference/getAllColorDefault/'));

    const {error, errorInfo, result, message, data } = response.data;
    const AllColorServer = data;

    // console.log('Сервер вернул данные по цветам - ',data);


    return AllColorServer;
};

Mock.onGet('/api/reference/allColor').reply(async (config) => {
    // const response = await NotificationDB.list
    // return [200, response]

    const AllColorServer = await getAllColorServer();

    if (!AllColorServer) {
        return [400, { message: 'Список цветов отсутствует!' }]
    }

    // const accessToken = user.accessToken;

    return [
        200,
        AllColorServer,
    ]


})